import H4 from "../../ui/Typography/Headings/H4/styled";
import React from "react";
import TextareaAutogrow from "../../ui/TextareaAutogrow";
import getSchoolOrderSelector from "../../../../state/selectors/SchoolSelectors/getSchoolOrderSelector";
import styled from "styled-components";
import useEditingSchoolField from "../../../../state/hooks/SchoolHooks/useEditingSchoolField";
import { useSelector } from "react-redux";

const SchoolTitle: React.FC = () => {
    const { isEditing, savedValue, editedValue, editSchoolField } = useEditingSchoolField("post_title");
    const order = useSelector((state: Store) => getSchoolOrderSelector(state));
    return (
        <Wrapper>
            {isEditing ? (
                <TextareaAutogrow editedValue={editedValue} onChange={(value: string) => editSchoolField(value)} />
            ) : (
                <Title>
                    {order.length ? `${order.join(".")} - ` : null}
                    {savedValue}
                </Title>
            )}
        </Wrapper>
    );
};

export default SchoolTitle;

const Wrapper = styled.div`
    padding: 2rem 0 3rem 0;
    @media print {
        padding: 0 0 2rem 0;
    }
    textarea {
        text-align: center;
        font-weight: 100;
        font-size: 3rem;
    }
`;

const Title = styled(H4 as any)`
    text-align: center;
    font-weight: 100;
    font-size: 3rem;
    @media print {
        font-size: 2rem;
    }
`;
